export const API_HOST_USERS = process.env.REACT_APP_API_HOST_USERS!;
export const API_HOST_ORGS = process.env.REACT_APP_API_HOST_ORGS!;
export const API_HOST_REFDATA = process.env.REACT_APP_API_HOST_REFDATA!;
export const API_HOST_SEARCH = process.env.REACT_APP_API_HOST_SEARCH!;
export const API_HOST_SVR = process.env.REACT_APP_API_HOST_SVR!;
export const API_HOST_NOTIFICATIONS =
 process.env.REACT_APP_API_HOST_NOTIFICATIONS!;
export const API_HOST_COMMS = process.env.REACT_APP_API_HOST_COMMS!;
export const SHARE_PORTAL_ROOT = process.env.REACT_APP_SHARE_PORTAL_ROOT!;
export const API_ROOT_COMMS = process.env.REACT_APP_API_HOST_COMMS!;
export const COMPLAINTS_API_ROOT = process.env.REACT_APP_COMPLAINTS_API_ROOT;
export const API_HOST_QUALS = process.env.REACT_APP_API_HOST_QUALS!;
export const API_HOST_LINKEDRECORDS =
 process.env.REACT_APP_API_HOST_LINKEDRECORDS!;
export const API_HOST_APQ = process.env.REACT_APP_API_HOST_APQ!;
export const API_HOST_PE = process.env.REACT_APP_API_HOST_PE!;
export const API_HOST_FOI = process.env.REACT_APP_API_HOST_FOI!;
export const API_HOST_SARS = process.env.REACT_APP_API_HOST_SARS!;
export const API_HOST_LCM = process.env.REACT_APP_API_HOST_LCM!;
